<info-navigation [type]="'active'" />
<div *ngIf="data?.length > 0; else placeholder">
  <ng-container *ngFor="let item of data; let i = index">
    <info-group [data]="item" [type]="'active'" [index]="i"></info-group>
  </ng-container>
</div>
<ng-template #placeholder>
  <div *ngIf="loading; else notLoading" class="placeholder">
    <p>Loading active projects...</p>
  </div>
  <ng-template #notLoading>
    <div class="placeholder">
      <p>You currently have no active projects.</p>
    </div>
  </ng-template>
</ng-template>

<site-visit-confirmation-dialog
  [active]="siteVisitConfirmationActive"
  (modalClose)="toggleCloseSiteVisitConfirmationModal()"
/>
